import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import Translate from 'translate';
import async from 'async';
import _ from 'lodash';

import ChannelCaseService from 'services/ChannelCaseService';
import { FormGroup, Text, Textarea2, Select } from 'components/FormElements';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import { required, validPhoneLEC } from 'constants/InputErrors';
import IncmsService from 'services/IncmsService';
import IncmsNewConn from 'services/IncmsNewConnService'


class AddImsNoAccountLECModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      options: {},
      options2: {},
      locations2: {},
      weathers:{},
      streets: null,
      divisions: null,
      locations: null,
      districs: null,
      landmark: null,
      codProvince: null,
      codDivision: null,
      codDistrict: null,
      codLocation: null,
      codStreet: null,
      phoneNumber: null,
      imsNature: null , 
      imsScope: null, 
      registerComment: null,
      incidentSubTypes:[],
      incidentTypes:[],
    };
    this.setDistrict = this.setDistrict.bind( this );
    this.setDivision = this.setDivision.bind( this );
    this.setLocation = this.setLocation.bind( this );
    this.setStreet = this.setStreet.bind( this );

    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( !this.props.open && nextProps.open ) {
      this.getData();
      // console.log(this.props.activeAccount)
      this.setState( { 
        landmark: (this.props.activeAccount && this.props.activeAccount.fullName) ? this.props.activeAccount.fullName : null ,
        phoneNumber: (this.props.activeAccount && this.props.activeAccount.phone) ? this.props.activeAccount.phone : null 
      } );
    }
  }


  setDistrict = cod_pro => {
    this.props.toggleLoading( true );
    IncmsNewConn.getProvinces( cod_pro ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ){
        this.setState ( {
          codProvince:cod_pro, 
          codDistrict: null, 
          codDivision: null,
          divisions: null,
          codLocation: null,
          locations:null,
          codStreet: null,
          streets: null,
          districs: _.orderBy( response.data, 'locationName' )} )
      }
    } )
  };


  setDivision = cod_district => {
    this.props.toggleLoading( true );
    IncmsNewConn.getCities( this.state.codProvince, cod_district ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ){
        this.setState ( { 
          codDistrict: cod_district, 
          codDivision: null,
          codLocation: null,
          locations:null,
          codStreet: null,
          streets: null,
          divisions: _.orderBy( response.data, 'locationName' )} )
      }
    } )
  };


  setLocation = cod_division => {
    this.props.toggleLoading( true );
    IncmsNewConn.getLocalities(this.state.codProvince, cod_division , this.state.codDistrict ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ){
        this.setState ( {
          codDivision: cod_division, 
          codLocation: null,
          locations:null,
          codStreet: null,
          streets: null,
          locations: _.orderBy( response.data, 'locationName' )} )
      }
    } )
  };

  setStreet = cod_location => {
    this.props.toggleLoading( true );
    IncmsNewConn.getStreet( this.state.codProvince,  this.state.codDivision, this.state.codDistrict, cod_location ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ){
        this.setState ( {codLocation: cod_location,  streets: _.orderBy( response.data, 'locationName' )} )
      }
    } )
  };
  setStateStreet = cod_street => {
    this.setState ( {codStreet: cod_street } )
  };

  getIncidentSubTypes( id ) {
    const { toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    IncmsService.getIncidentSubTypes( id ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) toggleAlertError( response.errors );
      this.setState( {incidentSubTypes: _.orderBy( response.data, 'description' ) } )
      
    } );
  }

  getData() {
    this.props.toggleLoading( true );

    async.parallel( {
      options: ( cb ) => {
        IncmsService.getIncidentTypes().then( ( response ) => {
          if( !response.data ) return cb(null,[]);
          return cb( null, {
            nature: _.orderBy( response.data, 'description' ),
          } );
        } )

      },



      options2: ( cb ) => {
        IncmsNewConn.getCountries().then( ( response ) => {
          if( !response.data ) return cb(null,[]);
          return cb( null, {
            province: _.orderBy( response.data, 'locationName' ),
          } );
        })
      },

      locations2: ( cb ) => {
        IncmsService.getLocations().then( ( response ) => {
          if( !response.data ) return cb(null,[]);
          return cb( null, {
            locations: _.orderBy( response.data, 'locationName' ),
          } );
        } )
      },
      weathers: ( cb ) => {
        IncmsService.getWeatherConditions().then( ( response ) => {
          if( !response.data ) return cb(null,[]);
          return cb( null, {
            weathers: _.orderBy( response.data, 'weatherName' ),
          } );
        } )
      },

      /*landmark: ( cb ) => {
        IncmsService.getLandmark( this.props.activeAccount.id ).then( ( response ) => {
          if( !response.data ) return cb();
          return cb( null, response.data && response.data.landmark ? response.data.landmark : null );
        } )
      }*/
    }, ( error, results ) => {
      this.props.toggleLoading( false );
      if( results ) this.setState( results )
    } )
  }

  submitForm( data ) {
    const { channel, onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;

    toggleLoading( true );

    data.channel = channel.id;
    data.typeCase = 'ims';
    // data.account = this.props.activeAccount.id;

    let dataToSend = {
      "codStreet": data.codStreet,
      "location": data.location,
      "codWeather": data.codWeather,
      "channel": channel.id,
      "customerName": data.imsLandmark,
      "imsNature": data.imsNature,
      "imsScope": data.imsScope,
      "phoneNumber": data.phoneNumber,
      "registerComment": data.registerComment,
      "typeCase": "ims"
    };
    this.setState ({codStreet: data.codStreet, phoneNumber: data.phoneNumber, imsNature: data.imsNature, imsScope: data.imsScope, registerComment: data.registerComment});
    ChannelCaseService.saveCase( dataToSend ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) {
        toggleAlertError( response.errors );
        this.setState ( {
          streets: null,
          divisions: null,
          locations: null,
          districs: null,
          landmark: null,
          codProvince: null,
          codDivision: null,
          codDistrict: null,
          codLocation: null,
          codStreet: null,
          phoneNumber: null,
          imsNature: null , 
          imsScope: null, 
          registerComment: null,}
        );
        onClose();
        return 
      
      }

      this.props.toggleAlertError( `Complaint Number: ${response.data.complaintNumber || '---'}`, response.data.complaintNumber );
      onReloadData( channel.id );
      onClose()
    } )
  }

  render() {
    const { onClose, open } = this.props;

    return (
      <Modal closeOnEsc={false}
             closeOnOverlayClick={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="addIMS"/></h5>

        <Form onSubmit={this.submitForm}
              defaultValues={{ 
                imsLandmark: this.state.landmark ? _.trim(this.state.landmark) : '', 
                codProvince: this.state.codProvince,
                codLocation: this.state.codLocation,
                location: this.state.location,
                codDivision: this.state.codDivision,
                codDistrict: this.state.codDistrict,
                phoneNumber: this.state.phoneNumber,
                codStreet: this.state.codStreet,
                imsNature: this.state.imsNature , 
                imsScope: this.state.imsScope, 
                registerComment: this.state.registerComment,
                codWeather: this.state.codWeather,
              }}
              validate={( values ) => ( {
                phoneNumber: required( values.phoneNumber ),
                imsNature: required( values.imsNature ),
                imsScope: required( values.imsScope ),
                imsLandmark: required( values.imsLandmark ),
                codDistrict: required( values.codDistrict ),
                codDivision: required( values.codDivision ),
                codLocation: required( values.codLocation ),
                codProvince: required( values.codProvince ),
                codStreet: required( values.codStreet ),
                registerComment: required( values.registerComment ),

              } )}
        >
          {( { setValue, getValue, submitForm } ) =>
            <form onSubmit={submitForm}>

              <div className="row">
                <FormGroup containerClass="col-md-4">
                  <label><Translate id="name"/></label>
                  <Text field="imsLandmark" className="form-control"  onChange={( value ) => {  this.setState( { landmark: value }) }}/>
                </FormGroup>

                <FormGroup containerClass="col-md-4">
                  <label><Translate id="phone"/></label>
                  <Text field="phoneNumber" className="form-control" onChange={( value ) => {  this.setState( { phoneNumber: value }) }}/>
                </FormGroup>

                <FormGroup containerClass="col-md-4">
                  <label><Translate id="location"/></label>
                  <Select field="location" className="form-control" placeholder=""
                          labelKey="description"
                          valueKey="id"
                          onChange={( value ) => {  this.setState( { location: value }) }}
                          options={this.state.locations2.locations}/>
                </FormGroup>
              </div>
              <div className="row">


                <FormGroup containerClass="col-md-4">
                  <label><Translate id="regionCounty"/></label>
                  <Select field="codProvince" className="form-control" placeholder=""
                          labelKey="locationName"
                          valueKey="locationCode"
                          onChange={this.setDistrict}
                          options={this.state.options2.province}/>
                </FormGroup>
                <FormGroup containerClass="col-md-4">
                  <label><Translate id="district"/></label>
                  <Select field="codDistrict" className="form-control" placeholder=""
                          labelKey="locationName"
                          valueKey="locationCode"
                          onChange={this.setDivision}
                          options={this.state.districs}/>
                </FormGroup>
                <FormGroup containerClass="col-md-4">
                  <label><Translate id="zone"/></label>
                  <Select field="codDivision" className="form-control" placeholder=""
                          labelKey="locationName"
                          valueKey="locationCode"
                          onChange={this.setLocation}
                          options={this.state.divisions}/>
                </FormGroup>
              </div>

              <div className="row">

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="community"/></label>
                  <Select field="codLocation" className="form-control" placeholder=""
                          labelKey="locationName"
                          valueKey="locationCode"
                          onChange={this.setStreet}
                          options={this.state.locations}/>
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="street"/></label>
                  <Select field="codStreet" className="form-control" placeholder=""
                          labelKey="locationName"
                          valueKey="locationCode"
                          onChange={( value ) => {  this.setState( { codStreet: value }) }}
                          options={this.state.streets}/>
                </FormGroup>
              </div>


              

              <div className="row">
                <FormGroup containerClass="col-md-4">
                  <label><Translate id="incidentType"/></label>
                  <Select field="imsNature" className="form-control" placeholder=""
                          labelKey="description"
                          onChange={( value ) => {
                            this.getIncidentSubTypes(value);
                            this.setState( { imsNature: value }) 
                          }}
                          options={this.state.options.nature}/>
                </FormGroup>

                <FormGroup containerClass="col-md-4">
                  <label><Translate id="incidentSubType"/></label>
                  <Select field="imsScope" className="form-control" placeholder=""
                          labelKey="description"
                          onChange={( value ) => {  this.setState( { imsScope: value }) }}
                          options={this.state.incidentSubTypes}/>
                </FormGroup>
                <FormGroup containerClass="col-md-4">
                  <label><Translate id="weatherCondition"/></label>
                  <Select field="codWeather" className="form-control" placeholder=""
                          labelKey="description"
                          valueKey="id"
                          onChange={( value ) => {  this.setState( { codWeather: value }) }}
                          options={this.state.weathers.weathers}/>
                </FormGroup>
              </div>
              <div className="row">
                <FormGroup containerClass="col-md-8">
                  <label><Translate id="description"/></label>
                  <Textarea2 
                          field="registerComment" 
                          className="form-control"
                          onChange={( value ) => {  this.setState( { registerComment: value }) }}
                  />
                </FormGroup>


              </div>

              <div className="text-right">
                <button className="btn btn-info"><Translate id="submit"/></button>
              </div>
            </form>
          }
        </Form>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message, msgToCopy ) => {
    dispatch( toggleAlertError( message, msgToCopy ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( AddImsNoAccountLECModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/AddImsNoAccountLECModal/index.js